import { TIMING } from '../config/timing.js';
import { distanceM } from '../geo/distance.js';
export const INITIAL_STANDING = Object.freeze({
    anchor: null,
    at: 0,
    since: null,
});
export function updateStanding(previous, sample, input) {
    const hier = { lat: sample.lat, lon: sample.lon };
    const grenze = input.movingDistanceM ?? TIMING.movingDistanceM;
    const lücke = input.previousAt === null || sample.recordedAt - input.previousAt > input.gapMs;
    // Erste Meldung oder erste nach einer Lücke: Der Stillstand zählt ab jetzt.
    // Vor der Lücke lässt sich nichts behaupten.
    if (lücke || previous.anchor === null) {
        return { anchor: hier, at: sample.recordedAt, since: sample.recordedAt };
    }
    // Weit genug vom Anker fort: Das Fahrzeug fährt, und der Anker wandert mit.
    if (distanceM(previous.anchor, hier) > grenze) {
        return { anchor: hier, at: sample.recordedAt, since: null };
    }
    // In der Nähe geblieben — aber noch nicht lange genug, um von Stillstand zu
    // sprechen. Ein fahrendes Fahrzeug ist zwischen zwei Meldungen nie weit von
    // der Stelle entfernt, an der es eben noch war; ohne diese Wartezeit fiele es
    // im Sekundentakt auf „steht" zurück und wieder heraus.
    if (previous.since === null && sample.recordedAt - previous.at < TIMING.standingConfirmMs) {
        return previous;
    }
    // In der Nähe des Ankers geblieben: Es steht — seit der Anker gesetzt wurde.
    return { anchor: previous.anchor, at: previous.at, since: previous.since ?? previous.at };
}
//# sourceMappingURL=standing.js.map